/**
 * Map manufacturing-order source type onto a Create * kind.
 *
 * @param {string} sourceType `sale`, `purchase`, or `transfer`.
 * @return {string}
 */
export const sourceCreateKind = sourceType => {
  if (sourceType === "purchase") return "purchaseOrder";
  if (sourceType === "transfer") return "transferOrder";
  return "saleOrder";
};
